import { Environments } from "@/config/env";
import { userStorage } from "@/lib/storage/user";
import { utmStorage } from "@/lib/storage/utm";

interface GtmEvent {
  event: string;
  [key: string]: unknown;
}

declare global {
  interface Window {
    dataLayer?: GtmEvent[];
  }
}

export function track(event: GtmEvent) {
  if (typeof window === "undefined") return;
  if (import.meta.env.VITE_ENVIRONMENT === Environments.LOCAL) {
    return;
  }

  const user = userStorage.get();
  const utm = utmStorage.read();

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    ...utm,
    ...(user && { user_id: user.user_id }),
    ...event,
  });
}
